import Login from './login.vue';
import UserName from './user-name.vue';
import Password from './password.vue';
import Mobile from './mobile.vue';
import Email from './email.vue';
import Captcha from './captcha.vue';
import Submit from './submit.vue';

Login.UserName = UserName;
Login.Password = Password;
Login.Mobile = Mobile;
Login.Email = Email;
Login.Captcha = Captcha;
Login.Submit = Submit;

export default Login;


// WEBPACK FOOTER //
// ./src/components/login/index.js